import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';

import Routes from './routes/Routes';

import './App.css';
import { muiTheme } from './theme';

import { SnackbarProvider } from 'notistack';
import { Slide } from '@material-ui/core';

import CustomSnackBar from './components/common/CustomSnackBar';
import BeeHeardWidget from './utils/BeeHeardWidget';

class App extends Component {
  render() {
    const { store, user } = this.props;
    return (
      <Provider store={store}>
        <ThemeProvider theme={muiTheme}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            TransitionComponent={Slide}
            content={(key, message) => <CustomSnackBar id={key} {...message} />}
          >
            <HashRouter hashType={'noslash'}>
              <Routes user={user} />
              <BeeHeardWidget />
            </HashRouter>
          </SnackbarProvider>
        </ThemeProvider>
      </Provider>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(App);
